export const BREAKUP_DEJECTED = 'breakupDejected'
export const SOLICITING_OPINION = 'solicitingOpinion'
export const CATHOLIC_PENSIVE = 'catholicPensive'
export const CATHOLIC_IDEA = 'catholicIdea'
export const PIOUS = 'pious'
export const PONDERING = 'pondering'
export const RUBIKS_CUBE = 'rubiksCube'
export const COUCH_READING = 'couchReading'
export const DISTRACTED = 'distracted'
export const HOPELESSLY_CRUSHED = 'hopelesslyCrushed'
export const WONDERING_BABY = 'wonderingBaby'
export const MERRILY_DERANGED = 'merrilyDeranged'
export const DISHROOM_READING = 'dishroomReading'
export const MOP_SOPPED = 'mopSopped'
export const WAITING_ROOM_ASLEEP = 'waitingRoomAsleep'
export const SIDELONG_HESITANCE = 'sidelongHesitance'
export const REMOVING_SHOES = 'removingShoes'
export const SHOES_REFLECTION = 'shoesReflection'
export const DROPPING_MEATS = 'droppingMeats'
export const CORD_SIDE = 'cordSide'
export const CORD_REAR = 'cordRear'
export const REMOVING_PANTS = 'removingPants'
export const INFIRM = 'infirm'
export const DISPOSING_CONDOM = 'disposingCondom'
export const CAMPUS_ASHAMED = 'campusAshamed'
export const SHOW_ANNOYED = 'showAnnoyed'
export const ALLEY = 'alley'
export const BROKEN_HEARTED = 'brokenHearted'
export const DEMONSTRATION = 'demonstration'
